import type { GetObligationAssessmentResultAuditByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import { GetObligationAssessmentResultAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetObligationAssessmentResultAuditByIdArgs = {
  id: string;
};

export const useGetObligationAssessmentResultAuditById = createQueryHook<
  UseGetObligationAssessmentResultAuditByIdArgs,
  GetObligationAssessmentResultAuditByIdResponseRow[],
  AuditLogQueryResult<
    'obligation_assessment_result_audit',
    GetObligationAssessmentResultAuditByIdResponseRow
  >
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getObligationAssessmentResultAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({
    obligation_assessment_result_audit: data,
  }),
  graphqlDocument: GetObligationAssessmentResultAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
